import { useSelector } from 'react-redux'
import { routeNameMap } from '@kaidam/fc-shared/src/frontend/router/utils'
import routerSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/router'
import routes from '../router/routes'

const useFullRoute = ({

} = {}) => {
  const route = useSelector(routerSelectors.route)
  const routeMap = routeNameMap(routes)
  const fullRoute = routeMap[route.name]
  return {
    route,
    fullRoute,
  }
}

export default useFullRoute
